import { render, staticRenderFns } from "./ContactsFragmentNoResult.vue?vue&type=template&id=4f98e243&"
import script from "./ContactsFragmentNoResult.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentNoResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports